import React from "react";

import { LinkHandler } from "@/components/common/LinkHandler";
import { GA4 } from "@/utils/ga4Utils";
import { cn } from "@/utils/general";
import { ThemeTypes } from "@/utils/theming";

import styles from "./index.module.scss";
import LogoSVGDesktop from "./LogoSVGDesktop";
import LogoSVGDesktopMen from "./LogoSVGDesktopMen";

const getThemeConfig = (theme: ThemeTypes, isSimple: boolean) => {
  switch (theme) {
    case "men":
      return {
        path: "/men/",
        logo: <LogoSVGDesktopMen isSimple={isSimple} />,
        className: styles.logoImageHolderMen,
      };
    case "master":
    default:
      return {
        path: "/",
        logo: <LogoSVGDesktop isSimple={isSimple} />,
        className: styles.logoImageHolder,
      };
  }
};

interface LogoProps {
  isSimple?: boolean;
  isAccountPage?: boolean;
  handleNavLogoExitClick?: () => void;
  theme?: ThemeTypes;
}

const Logo: React.FC<LogoProps> = (props) => {
  const { isSimple, isAccountPage, handleNavLogoExitClick, theme = "master" } = props;

  const { path, logo, className } = getThemeConfig(theme, isSimple);

  const trackLogoClick = () => {
    GA4.onNavigationClicked({
      destination: path,
      type: "link",
    });

    handleNavLogoExitClick?.();
  };

  return (
    <div className={cn(styles.logoArea, "logo-wrap")} onClick={trackLogoClick}>
      <LinkHandler path={path}>
        <span className={cn(className, isAccountPage ? styles.isAccountPage : styles.genericPage)}>
          {logo}
        </span>
      </LinkHandler>
    </div>
  );
};

export default Logo;
